import React, { useState } from "react";
import {
  MdOutlineArrowOutward,
  MdLightMode,
  MdOutlineLightMode,
} from "react-icons/md";
import { useContext } from "react";
import { useTheme } from "../contexts/ThemeContext";
import { Link } from "react-router-dom";

const Navbar = () => {
  const { mode, toggleMode } = useTheme();

  return (
    <nav
      className={`flex justify-between items-center p-4 transition-all duration-300 ${
        mode === "light" ? "bg-white text-gray-800" : "bg-gray-900 text-white"
      }`}
    >
      <div className="flex space-x-6">
        <div className="text-xl font-bold hover:text-indigo-600 transition-colors">
          <Link to="/">Manish</Link>
        </div>
        <div className="text-xl hover:text-indigo-600 transition-colors">
          <Link to="/work">work</Link>
        </div>
        <div className="text-xl hover:text-indigo-600 transition-colors">
          <Link to="/notes">notes</Link>
        </div>
        <a
          className="flex items-center text-xl hover:text-indigo-600 transition-colors"
          href="https://linktr.ee/manish.react"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>socials</span>
          <MdOutlineArrowOutward className="ml-1" />
        </a>
      </div>
      <button
        onClick={toggleMode}
        className="p-2 rounded-md transition-colors focus:outline-none hover:bg-gray-200 dark:hover:bg-gray-800"
        aria-label="Toggle dark mode"
      >
        {mode === "light" ? (
          <MdLightMode className="text-2xl" />
        ) : (
          <MdOutlineLightMode className="text-2xl" />
        )}
      </button>
    </nav>
  );
};

export default Navbar;
